import React from 'react'
import { useParams } from 'react-router-dom'
import { withUserStore } from '../../contexts/UserStore'
import { Input, Label } from '@byscott-io/corebyscott'
import PageView from './PageView'
import Lex from '../Shared/Lex'
// import {withGoalsApi} from "../../apis/goals_api"
import CommentThread from './CommentThread/CommentThread'
import JournalEntryThread from './JournalEntryThread/JournalEntryThread'
import PageProvider from '../../modules/PageProvider'

const Goals = ({userStore}) => {
  const { priorityId, strategyId } = useParams()
  const form = {}

  const getStrategy = (strategyId) => userStore.findRecord('strategies', strategyId)

  const getPriority = (priorityId) => userStore.findRecord('priorities', priorityId)

  const getStrategies = (priorityId) => {
    return userStore.getRecords('strategies', null, (s) => !priorityId || s.priorityId === priorityId)
  }

  const getPriorityId = () => {
    if (priorityId) return priorityId
    if (strategyId) return userStore.findRecord('strategies', strategyId).priorityId
    return null
  }

  const page = {
    //    clickUrl: (record) => "goal/" + record.id + "/tasks",
    clickUrl: () => 'tasks',
    formName: () => userStore.lex?.goal || 'Goal',
    recordType: () => 'goals',
    pageHeader: () => <h3 className="inline-block"><Lex term="goal" plural /></h3>,
    //    return <div><h4 className="inline-block">{ this.getPriorityId() ? "Priority:" : "Priorities:" }
    //             <DropdownSelect className="inline-block" selected={ this.props.userStore.findRecord('priorities', this.getPriorityId()) || { name: 'All', id: null }} options={[{name: 'All', id: null}].concat(this.props.userStore.getRecords('priorities'))} callback={(selected) => this.props.history.push(selected.id ? "/app/priority/"+selected.id+"/goals" : "/app/goals")} /></h4>
    // <FontAwesomeIcon icon={faArrowRight}/>&nbsp;&nbsp;
    //    <h4 className="inline-block">{ this.props.strategyId ? "Strategy:" : "Strategies:" }
    //             <DropdownSelect className="inline-block" selected={ this.props.userStore.findRecord('strategies', this.props.strategyId) || { name: 'All', id: null }} options={[{name: 'All', id: null}].concat(this.getStrategies(this.getPriorityId()))} callback={(selected) => this.props.history.push(selected.id ? "/app/strategy/"+selected.id+"/goals" : "/app/goals")} /></h4>
    //
    // <FontAwesomeIcon icon={faArrowRight}/>&nbsp;&nbsp;
    // <h3 className="inline-block">Goals</h3> </div>
    newRecord: () => {
      return { name: '', description: '', strategyId, type: 'Goal' }
    },
    records: () => {
      return userStore.getRecords('goals', (a, b) => ((a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : (b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0))
    },
    filterRecords: (g) => {
      return (!getPriorityId() || getStrategies(getPriorityId()).filter((s) => s.id === g.strategyId).length > 0) && (!strategyId || strategyId === g.strategyId)
    },
    formFields: (record) => {
      record = record || { name: '', description: '', strategyId, type: 'Goal' }
      return (
        <div>
          <Label>Name</Label>
          <Input data-cy="goal-name-input" innerRef={el => form.name = el} defaultValue={record.name} /> <br />
          <Label><Lex term="description" /></Label><Input
            data-cy="goal-description-input"
            innerRef={el => form.description = el}
            defaultValue={record.description}
          /> <br />
          <Label><Lex term="strategy" /></Label><Input
            type="select" innerRef={el => form.strategyId = el}
            defaultValue={record.strategyId}
          >
            {userStore.getRecords('strategies').map((t, index) => <option
              key={index}
              value={t.id}
            >{t.name}
            </option>)}
          </Input>
        </div>)
    },
    saveRecord: (record) => {
      record.name = form.name.value
      record.description = form.description.value
      record.strategyId = form.strategyId.value
      if (record.id) { userStore.updateGoal(record) } else { userStore.createGoal(record.name, record.description, null, record.strategyId, userStore.account?.id) }
      return true
    },
    destroy: (record) => userStore.destroyGoal(record),
    renderRecord: (record, mode) => {
      const strategy = getStrategy(record.strategyId)
      const priority = getPriority(strategy.priorityId)
      if (mode === 'Tile') {
        return <div>
          <Lex term="priority" />{': ' + priority.name}<br />
          <Lex term="strategy" />{': ' + strategy.name}<br />
          <Lex term="goal" />{': ' + record.name}
        </div>
      } else {
        return <div>
          <Lex term="priority" />{': ' + priority.name} <i className="fas fa-arrow-right" />
          <Lex term="strategy" />{': ' + strategy.name} <i className="fas fa-arrow-right" />
          <Lex term="goal" />{': ' + record.name}
        </div>
      }
    },
    showJournal: true,
    journalThreadPageProvider: PageProvider({
      formFields: (record) => <JournalEntryThread goalId={record.id} taskId={null} content={record.name} />,
      record: () => { return {} }
    }),
    showComment: true,
    commentThreadPageProvider: PageProvider({
      formFields: (record) => <CommentThread commentable={record} content={record.name} />,
      record: () => { return {} }
    })
  }

  return <PageView pageProvider={PageProvider(page)} />
}

export default withUserStore(Goals)
